import { useQuery } from '@tanstack/react-query';
import type { MetricTypeToken } from '@sleed/bizcommerce-api';
import { metricTypesApi } from '~/lib/api/client';

/** All metric types (small reference table) for the `metricTypes` dynamic-filter editor. */
export function useMetricTypesList() {
	return useQuery<MetricTypeToken[]>({
		queryKey: ['lookups', 'metric-types'],
		staleTime: 5 * 60_000,
		queryFn: async () => (await metricTypesApi.lookup()).data ?? []
	});
}
